module.exports = __webpack_public_path__ + "media/components/shared/static/triangle_down-b73eeaf42cc12c741b6ada75c4f6e4fa.svg";